import { render, staticRenderFns } from "./MaterailsOverview.vue?vue&type=template&id=3041dc7c&scoped=true"
import script from "./MaterailsOverview.vue?vue&type=script&lang=js"
export * from "./MaterailsOverview.vue?vue&type=script&lang=js"
import style0 from "./MaterailsOverview.vue?vue&type=style&index=0&id=3041dc7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041dc7c",
  null
  
)

export default component.exports